import { Injectable } from "@angular/core";
import { environment } from "src/environments/environment";
import { z } from "zod";
import { AccessModule, AccessModuleResponse, AlivCustomerSchema, BTCProductPlan, BTCProductPlanSchema, BTCProductSchema, BTC_CATEGORY, BankDepositSchema, Country, FeeSchema, GamingHouserPlayer, GovernmentPaymentSchema, PrepaidPlan, SandDollarQRSchema, SendMoneySchema, SuncashQRSchema, TopupTransactionSchema, UtilityBiller, UtilityCustomerSchema } from "../core/model/api";
import { RecentBank, } from "../kiosk/bank-deposit/receiver-info/receiver-info.component";
import { BUSINESS_SERVICE_WITHDRAWAL_FEE } from "../kiosk/business-services/business-services.service";
import { RecentUtility } from "../kiosk/utility/recent-list/receiver-info.component";

export type FEE_TYPE = 'CASHOUT' | 'GAMINGWITHDRAWAL_KIOSK' | 'GAMINGDEPOSIT_KIOSK' | 'VOUCHER_KIOSK' | 'SANDDOLLAR_SEND' | 'SANDDOLLAR_LOAD' | 'BUSINESSBILLPAY' | 'PHONESTORE' | 'GOVERNMENTPAY' | 'WITHDRAWAL_SANDDOLLAR' | 'BILLPAYKIOSK' | 'PAYMENTCODE_KIOSK' | 'DOMESTICSENDMONEY_KIOSK' | 'SUNCASHWITHDRAWAL_KIOSK' | 'SUNCASHDEPOSIT_KIOSK' | 'BUSINESSPAYMENT_KIOSK' | 'KIOSK_TOPUP' | typeof BUSINESS_SERVICE_WITHDRAWAL_FEE | "KIOSK_CARD_WITHDRAWAL" | "KIOSK_CARD_DEPOSIT" | "WESTERN_UNION"
export const BILL_ACCEPTOR_WAIT = 1
export type CarrierProvider = {
  name: string,
  logo_url: string,
  code: string,
  country_code: string,
  carrierId: number
}
export type Carrier = {
  carrierId: number,
  carrierName: string,
  category: string,
  countryCode: string,
  productId: number,
  operator: string,
  denominationType: string,
}
export type ZAdmin = {
  sessionid: string,
  id: number,
  first_name: string,
  last_name: string,
  username: string,
  email_address: string,
}
export type APIType<T, TResponse> = {
  method: string,
  types?: T,
  params: { [Property in keyof T]: string },
  response_data?: string,
  response_types?: TResponse,
}
@Injectable()
export class constants {
  public readonly API_ENDPOINT: string = environment.api
  public readonly IS_PROD: boolean = environment.is_prod

  public readonly SIGNALR_ENDPOINT: string = 'http://localhost:60559/signalr';
  public readonly LOCKDOWN_ENDPOINT: string = 'http://localhost:63944/signalr';
  //SUNCASH API
  public readonly KIOSK_LOGIN_METHOD: string = 'logInKiosk';
  public readonly SUNCASH_LOGIN_METHOD: string = 'suncashCustomerAccessToken';
  public readonly KIOSK_P01: string = this.IS_PROD ? 'FPTUser001' : 'XENTRA-01';
  public readonly KIOSK_P02: string = this.IS_PROD ? 'FPT@admin' : 'xentra@dev';
  public readonly KIOSK_P03: string = this.IS_PROD ? 'FPT0001' : 'XENTRA-01';
  // public readonly SUNCASH_DEPOSIT_METHOD: string = 'loadWallet';
  // public readonly SUNCASH_WITHDRAW_METHOD: string = 'suncashWithdawal';
  //Gaming Houses API
  public readonly GAME_LIST_METHOD: string = 'getGamingHouses';
  public readonly GAME_VALIDATE_METHOD: string = 'gamingHousePlayerValidation';
  public readonly GAME_DEPOSIT_METHOD: string = 'gamingHouseDeposit';
  public readonly GAME_WITHDRAW_METHOD: string = 'gamingHouseWithdraw';
  //VOUCHERS AND GIFT CARD API
  public readonly COUNTRY_LIST_METHOD: string = 'getCountries';
  public readonly LOCAL_VOUCHER_LIST_METHOD: string = 'getVoucherProducts';
  public readonly LOCAL_VOUCHER_SELL_METHOD: string = 'sellVoucher';
  public readonly LOCAL_VOUCHER_CONVERT_PRICE_METHOD: string = 'convertToSellingPrice';
  public readonly LOCAL_GIFT_CARD_LIST_METHOD: string = 'getLgcProducts';
  public readonly INT_GIFT_CARD_LIST_METHOD: string = 'getMgoProducts';
  public readonly INT_GIFT_CARD_SEND_METHOD: string = 'sendMoneyMgo';
  //BUSINESS PAYMENTS
  public readonly BUSINESS_BILLERS: string = 'getBusinessBillers'
  //GOVERNMENT PAYMENTS
  public readonly GOVERNMENT_GET_TOKEN: string = 'govPayGetToken'
  public readonly GOVERNMENT_INVOICE_REFERENCE: string = 'govPayGetInvoiceByReference'
  public readonly GOVERNMENT_INVOICE_NUMBER: string = 'govPayGetInvoiceByInvoiceNumber'
  //TOP UP
  public readonly MOBILE_OPERATOR: string = 'getMobileOperator'
  public readonly CARRIER_LIST: string = 'getCarrierList'
  public readonly SKUPERCARRIER: string = 'getSkuPerCarrier'
  public readonly ALIVCUSTOMERINFO: string = 'alivCustomerInfo'
  public readonly ALIVPRODUCTALL: string = 'alivProductsAll'

  //UTILITY
  // public readonly UTILITY_BILLER: string = 'billpayGetBillersPerCountry'
  public readonly UTILITY_BILL_INFO: string = 'getCustomersBillInfo'
  public readonly DB_UTILITY_ACCOUNT = 'DB_UTILITY_ACCOUNT'

  //BANK DEPOSIT
  // public readonly BANK_DEPOSIT_BANK_LIST: string = 'getKioskBankList'
  // public readonly BANK_DEPOSIT_BRANCH_LIST: string = 'getKioskBranchesPerBank'



  //FEE COMPUTATION
  public readonly COMPUTE_FEE_METHOD: string = 'computeFee';
  public readonly RETURN_MODE: string = 'json';

  // public readonly FEE_SUNCASH_DEPOSIT = 'LOAD';
  // public readonly FEE_SUNCASH_WITHDRAW = 'CASHOUT';
  public readonly FEE_BUSINESS_PAY = 'BUSINESSPAYMENT_KIOSK';
  public readonly FEE_GOVERNMENT_PAY = 'GOVERNMENTPAY';
  public readonly FEE_SEND_MONEY = 'DOMESTICSENDMONEY_KIOSK';
  public readonly FEE_TOPUP = 'KIOSK_TOPUP';
  public readonly FEE_UTILITY_KIOSK = 'BILLPAYKIOSK';
  //ENABLE / DISABLE KIOSK FUNCTIONS
  // public readonly KIOSK_ENABLED: boolean = true;
  // public readonly LOGS_ENABLED: boolean = true;
  public readonly KIOSK_ENABLED: boolean = this.IS_PROD || !localStorage.getItem('qa_testing') ? environment.enableKiosk : false;
  public readonly LOGS_ENABLED: boolean = this.IS_PROD || !localStorage.getItem('qa_testing') ? environment.enableLogs : false;
  public readonly SUNCASH_KEY: string = this.IS_PROD ? '9b55ff5mlzcihh6ulxz65lccvvslk874svdu0zuv11ec67xmbrcbzu71lotouank' : 'e9c5f04e37cf67fe535b7aecfd4de2fa8424d087ffe39bb2ee8db173c7e07ba5';

  //PARKING FEE

  public readonly PARKING_OTHER_SERVICES = 'getParkingOtherServices';
  public readonly PARKING_ESTIMATE_FEE = 'estimateParkingFee';
  public readonly PARKING_OTHER_ESTIMATE_FEE = 'parkingOtherServicesFee';
  public readonly PARKING_FEE_VOUCHER = 'purchaseParkingFeeVoucher'

  //Storage
  public readonly DB_PARKING_CATEGORY = 'DB_PARKING_CATEGORY';
  public readonly DB_PARKING_amount = 'DB_PARKING_amount';
  public readonly DB_PARKING_ESTIMATE_FEE = 'DB_PARKING_ESTIMATE_FEE';
  public readonly DB_PARKING_ESTIMATE_SAVE = 'DB_PARKING_ESTIMATE_SAVE';
  public readonly DB_PARKING_save = 'DB_PARKING_ESTIMATE_FEE';
  public readonly DB_PARKING_AMOUNT = 'DB_PARKING_AMOUNT';
  public readonly DB_PARKING_VOUCHER_AMOUNT = 'DB_PARKING_VOUCHER_AMOUNT';
  public readonly DB_RELOAD_VOUCHER = 'DB_RELOAD_VOUCHER';

  public readonly TEL_MIN_LENGTH = 7
  public readonly POLL_SERVICES_INTERVAL = 30;
  public readonly BAHAMAS = {
    "country_id": "16",
    "code": "BS",
    "code2": "BHS",
    "currency_code": "BSD",
    "name": "Bahamas",
    "mobile_prefix": "1242",
    "flag": "https://dev.mysuncash.com/desktop/cardholders/images/country-flags/bs.png"
  }

  public readonly PHILIPPINES = {
    "country_id": "167",
    "code": "PH",
    "code2": "PHL",
    "currency_code": "PHP",
    "name": "Philippines",
    "mobile_prefix": "63",
    "flag": "https://dev.mysuncash.com/desktop/cardholders/images/country-flags/ph.png"
  }

  public readonly ADMIN_EMAIL = 'fastpay@mysuncash.com'

  public readonly FASTPAY = "FastPay"

  public readonly API_SESSION: APIType<{ username: string, password: string, deviceId: string }, AccessModuleResponse> = {
    method: this.KIOSK_LOGIN_METHOD,
    params: {
      username: 'P01',
      password: 'P02',
      deviceId: 'P03',
    },
  }

  public readonly API_COUNTRY_LIST
    : APIType<{ session: string }, z.infer<typeof Country>[]> = {
      method: 'getCountries',
      params: {
        session: 'P01'
      }
    };

  public readonly API_COMPUTE_FEE
    : APIType<{ session: string, amount: number, type: FEE_TYPE, extra_code?: string }, z.infer<typeof FeeSchema>>
    = {
      method: 'computeFee',
      params: {
        session: 'P01',
        amount: 'P02',
        type: 'P03',
        extra_code: 'P04',
      }
    }


  public readonly API_RECENT_BANKS: APIType<
    { session: string, mobile_number: string }, RecentBank[]
  > = {
      method: 'getKioskBankAccount',
      params: {
        session: 'P01',
        mobile_number: 'P02',
      }
    }

  public readonly API_RECENT_UTILITY: APIType<
    { session: string, mobile_number: string }, RecentUtility[]
  > = {
      method: 'getCustomerUtilityInfo',
      params: {
        session: 'P01',
        mobile_number: 'P02',
      }
    }

  public readonly API_DELETE_RECENT_BANKS = {
    method: 'deleteBankAccount',
    params: {
      session: 'P01',
      mobile_number: 'P02',
      id: 'P03'
    }
  }

  public readonly API_DELETE_RECENT_UTILITY = {
    method: 'deleteUtilityAccounts',
    params: {
      session: 'P01',
      mobile_number: 'P02',
      id: 'P03'
    }
  }

  public readonly API_ESTIMATE_PARKING_FEE = {
    method: 'estimateParkingFee',
    params: {
      session: 'P01',
      category: 'P02',
      start_date: 'P03',
      start_time: 'P04',
      end_date: 'P05',
      end_time: 'P06',
    }
  }

  public readonly API_RELOAD_VOUCHER = {
    method: 'reloadVoucher',
    params: {
      session: 'P01',
      voucher_code: 'P02',
      amount: 'P03',
      mobile: 'P04',
    },
    response_data: 'VoucherData'
  }

  public readonly API_PURCHASE_VOUCHER = {
    method: this.PARKING_FEE_VOUCHER,
    params: {
      session: 'P01',
      amount: 'P02',
      mobile: 'P03',
    },
    response_data: 'VoucherData'
  }

  public readonly API_LOCAL_GIFT_CARD: APIType<{
    session: string,
    product_type_id: number,
    email: string,
    amount: number,
    mobile: string,
  }, any> = {
      method: 'dispenseLocalVirtualGiftCard',
      params: {
        session: 'P01',
        product_type_id: 'P02',
        email: 'P03',
        amount: 'P04',
        mobile: 'P05',
      },
      response_data: 'GiftCardData'
    }

  public readonly API_LOCAL_VOUCHER_SELL = {
    method: this.LOCAL_VOUCHER_SELL_METHOD,
    params: {
      session: 'P01',
      customer_id: 'P02',
      mobile: 'P03',
      receiver_name: 'P04',
      amount: 'P05',
      fee: 'P06',
      email: 'P07',
      sku: 'P08',
      terminal_code: 'P09',
      vat: 'P10',
    },
  }

  public readonly API_INT_GIFT_CARD_SEND = {
    method: this.INT_GIFT_CARD_SEND_METHOD,
    params: {
      session: 'P01',
      total_amount: 'P02',
      face_amount: 'P03',
      mobile: 'P04',
      product: 'P05',
      clerk_id: 'P06',
      test_mode: 'P07',
      sku: 'P08',
      use_catalog: 'P09',
      reference_number: 'P10',
      send_code: 'P11',
      auto_update_code_version: 'P12',
      country_code: 'P13',
      first_name: 'P14',
      last_name: 'P15',
      _: 'P16',
    },
  }

  public readonly API_GAME_DEPOSIT: APIType<{
    session: string,
    gaming_house: string,
    token: string,
    pin: string,
    amount: number;
    customer_id: string;
    fee: number,
    vat: number,
    account_number: string,
  }, any> = {
      method: this.GAME_DEPOSIT_METHOD,
      params: {
        session: 'P01',
        gaming_house: 'P02',
        token: 'P03',
        pin: 'P04',
        amount: 'P05',
        customer_id: 'P06',
        fee: 'P07',
        vat: 'P08',
        account_number: 'P09'
      },
    }

  public readonly API_GAME_WITHDRAW: APIType<{
    session: string,
    gaming_house: string,
    token: string,
    pin: string,
    amount: number;
    customer_id: string;
    fee: number,
    vat: number,
    account_number: string,
    tx_id: string
  }, any> = {
      method: this.GAME_WITHDRAW_METHOD,
      params: {
        session: 'P01',
        gaming_house: 'P02',
        token: 'P03',
        pin: 'P04',
        amount: 'P05',
        customer_id: 'P06',
        fee: 'P07',
        vat: 'P08',
        account_number: 'P09',
        tx_id: 'kiosk_trx_id',
      },
    }

  public readonly API_GAME_VALIDATE:
    APIType<{ session: string, gaming_house: string, card: string, pin: string }, GamingHouserPlayer>
    = {
      method: this.GAME_VALIDATE_METHOD,
      params: {
        session: 'P01',
        gaming_house: 'P02',
        card: 'P03',
        pin: 'P04',
      },
    }

  // public readonly API_SUNCASH_DEPOSIT = {
  //   method: this.SUNCASH_DEPOSIT_METHOD,
  //   params: {
  //     session: 'P01',
  //     payment_type: 'P02',
  //     card: 'P03',
  //     amount: 'P04',
  //     fee: 'P05',
  //     vat: 'P06',
  //   },
  // }

  // public readonly API_SUNCASH_WITHDRAW = {
  //   method: this.SUNCASH_WITHDRAW_METHOD,
  //   params: {
  //     session: 'P01',
  //     payment_type: 'P02',
  //     card: 'P03',
  //     amount: 'P04',
  //     fee: 'P05',
  //     vat: 'P06',
  //     security_option: 'P07',
  //     pin: 'P08',
  //   },
  // }

  public readonly API_SUNCASH_LOGIN = {
    method: this.SUNCASH_LOGIN_METHOD,
    params: {
      session: 'P01',
      hashed_pin: 'P02',
      card: 'P03',
      payment_type: 'P04'
    },
  }

  public readonly API_SUNCASH_GENERATE_QR: APIType<{ session: string, type: string }, { QRCode: string }> = {
    method: 'generateTransactionQrCode',
    params: {
      session: 'P01',
      type: 'P02',
    },
  }

  public readonly API_SANDDOLLAR_GENERATE_QR: APIType<{ session: string, terminal_id: number, amount: number, payment_method: 'SANDDOLLAR' }, { referenceId: number, qrcode: string }> = {
    method: 'initiateTransaction',
    params: {
      session: 'P01',
      terminal_id: 'P02',
      amount: 'P03',
      payment_method: 'P04',
    },
  }

  public readonly API_SUNCASH_VALIDATE_QR: APIType<{
    session: string,
    qrcode: string,
  }, {
    Data: z.infer<typeof SuncashQRSchema>
  }> = {
      method: 'checkTransactionQrCode',
      params: {
        session: 'P01',
        qrcode: 'P02',
      },
    }

  public readonly API_SANDDOLLAR_VALIDATE_QR: APIType<{ session: string, terminal_id: number, payment_method: 'SANDDOLLAR', reference_id: number }, z.infer<typeof SandDollarQRSchema>> = {
    method: 'getPayTransaction',
    params: {
      session: 'P01',
      terminal_id: 'P02',
      payment_method: 'P03',
      reference_id: 'P04'
    },
  }
  public readonly API_SANDDOLLAR_PROCESS = {
    method: 'processTransaction',
    params: {
      session: 'P01',
      transaction_id: 'P02',
      payment_type: 'P03',
      // tx_id: 'kiosk_trx_id'
    },
  }

  public readonly API_MAINTENANCE_LOGIN: APIType<
    {
      admin_username: string,
      admin_password: string,
      kiosk_code: string,
      kiosk_name: string,
    },
    ZAdmin
  > = {
      method: 'zoutLogin',
      params: {
        admin_username: 'P01',
        admin_password: 'P02',
        kiosk_code: 'P03',
        kiosk_name: 'P04',
      },
    }

  public readonly API_ZTRAIL = {
    method: 'zoutAddZtrail',
    params: {
      session: 'P01',
      merchant_id: 'P02',
      branch_code: 'P03',
      terminal_code: 'P04',
      method_name: 'P05',
      request_params: 'P06',
      terminal_reference: 'P07',
      transaction_type: 'P08',
      USD_1: 'P09',
      USD_2: 'P10',
      USD_5: 'P11',
      USD_10: 'P12',
      USD_20: 'P13',
      USD_50: 'P14',
      USD_100: 'P15',
      BSD_1: 'P16',
      BSD_2: 'P17',
      // BSD_3: 'P18',
      BSD_5: 'P18',
      BSD_10: 'P19',
      BSD_20: 'P20',
      BSD_50: 'P21',
      BSD_100: 'P22',
      location: 'P23',
    },
  }

  public readonly API_GENERATE_SETTLEMENT: APIType<{ session: string }, string> = {
    method: 'zoutGenerateSettlementNo',
    params: {
      session: 'P01',
    },
  }

  public readonly API_SUBMIT_SETTLEMENT: APIType<{ session: string, merchant_id: string, branch_code: string, terminal_code: string, settlement_number: string, settlement_date: string, total_transactions: number, admin_username: string, location: string }, string> = {
    method: 'submitZoutSettlement',
    params: {
      session: 'P01',
      merchant_id: 'P02',
      branch_code: 'P03',
      terminal_code: 'P04',
      settlement_number: 'P05',
      settlement_date: 'P06',
      total_transactions: 'P07',
      admin_username: 'P08',
      location: 'P09',
    },
  }

  public readonly API_GET_TX_COUNT: APIType<{ session: string, merchant_id: string, branch_code: string, terminal_code: string }, { Count: number }> = {
    method: 'zoutGetcurrentTransactionCount',
    params: {
      session: 'P01',
      merchant_id: 'P02',
      branch_code: 'P03',
      terminal_code: 'P04',
    },
  }
  public readonly API_PREV_SETTLEMENT: APIType<{ session: string, merchant_id: string, branch_code: string, terminal_code: string }, { id: string, settlement_date: string, settlement_no: string }> = {
    method: 'zoutGetPreviousSettlement',
    params: {
      session: 'P01',
      merchant_id: 'P02',
      branch_code: 'P03',
      terminal_code: 'P04',
    },
  }

  public readonly API_SAND_DOLLAR_LOAD = {
    method: 'sandDollarLoadFunds',
    params: {
      session: 'P01',
      account: 'P02',
      cash: 'P03',
      fee: 'P04',
      is_custom_name: 'P05',
      vat: 'P06',
      is_fee_excluded: 'P08',
      transaction_type: 'P09'
    },
  }


  public readonly API_SAND_DOLLAR_SEND = this.API_SAND_DOLLAR_LOAD;

  public readonly API_MOBILE_WALLET_LOAD = {
    method: 'loadMobileWallet',
    params: {
      session: 'P01',
      account: 'P02',
      cash: 'P03',
      fee: 'P04',
      is_custom_name: 'P05',
      vat: 'P06',
      wallet_id: 'P07',
      is_fee_excluded: 'P08',
      transaction_type: 'P09'
    },
  }

  public readonly API_BUSINESS_PAYMENT: APIType<{ session: string, company: string, amount: number, fee: number, vat: number, reference_id: string | number }, { TransactionId: number }> = {
    method: 'processBusinessBillPay',
    params: {
      session: 'P01',
      company: 'P02',
      amount: 'P03',
      fee: 'P04',
      vat: 'P05',
      reference_id: 'P06',
    }
  }

  public readonly GOVERNMENT_PAY_REFERENCE: APIType<{
    session: string, token: string, type: string, invoice: string, customer_id: number, amount: number
  }, z.infer<typeof GovernmentPaymentSchema>
  > = {
      method: 'govPayProcessTransactionByReference',
      params: {
        session: 'P01',
        token: 'P02',
        type: 'P03',
        invoice: 'P04',
        customer_id: 'P05',
        amount: 'P06',
      }
    }

  public readonly GOVERNMENT_PAY_INVOICE: APIType<{
    session: string, token: string, type: string, invoice: string, customer_id: number, amount: number
  }, z.infer<typeof GovernmentPaymentSchema>
  > = {
      method: 'govPayProcessTransactionByInvoiceNumber',
      params: {
        session: 'P01',
        token: 'P02',
        type: 'P03',
        invoice: 'P04',
        customer_id: 'P05',
        amount: 'P06',
      }
    }

  public readonly API_SEND_MONEY: APIType<{
    session: string, sender_id: string, sender_name: string, sender_mobile: string, sender_email: string, receiver_name: string, receiver_mobile: string, receiver_email: string, amount: number, type: 'PICKUP' | 'DIRECT', receiver_id: string, receiver_type: 'old_user' | 'new_user', sender_type: 'old_user' | 'new_user'
  }, z.infer<typeof SendMoneySchema>
  > = {
      method: 'process_money_transfer_webpos',
      params: {
        session: 'P01',
        sender_id: 'P02',
        sender_name: 'P03',
        sender_mobile: 'P04',
        sender_email: 'P05',
        receiver_name: 'P06',
        receiver_mobile: 'P07',
        receiver_email: 'P08',
        amount: 'P09',
        type: 'P10',
        receiver_id: 'P11',
        receiver_type: 'P12',
        sender_type: 'P13'
      }
    }
  public readonly API_GET_SENDER: APIType<{
    session: string,
    mobile: string,
  }, {
    sender_id: string,
    first_name: string,
    last_name: string,
    account_type: "Non-Wallet" | "Wallet",
    mobile_number: string,
    email: string,
  }[]> = {
      method: 'getDomesticSenderInfo',
      params: {
        session: 'P01',
        mobile: 'P02'
      }
    };
  public readonly API_GET_RECEIVER: APIType<{
    session: string,
    mobile: string,
  }, {
    bene_id: string,
    first_name: string,
    last_name: string,
    account_type: "Non-Wallet" | "Wallet",
    mobile_number: string,
    email: string,
  }[]> = {
      method: 'getDomesticReceiverInfo',
      params: {
        session: 'P01',
        mobile: 'P02'
      }
    };

  public readonly API_SEND_MAIL = {
    method: 'send_email',
    params: {
      session: 'P01',
      email: 'P02',
      subject: 'P03',
      message: 'P04',
    }
  }

  public readonly API_LOG = {
    method: 'saveKioskLog',
    params: {
      session: 'P01',
      content: 'P02',
      terminal: 'P03'
    }
  }

  public readonly API_TOPUP_TRANSACTION: APIType<{
    session: string,
    carrier_id: string,
    carrier_name: string,
    country_id: number,
    payment_type: 'PinoyWallet' | 'TOPUP',
    sku_id: number,
    mobile_number: string,
    amount: number,
    provider: string,
    product_id: string,
    product_flow: string,
    invoice_number: boolean | '',
  }, z.infer<typeof TopupTransactionSchema>
  > = {
      method: 'processTopupTransaction',
      params: {
        session: 'P01',
        carrier_id: 'P02',
        carrier_name: 'P03',
        country_id: 'P04',
        payment_type: 'P05',
        sku_id: 'P06',
        mobile_number: 'P07',
        amount: 'P08',
        provider: 'P09',
        product_id: 'P10',
        product_flow: 'P11',
        invoice_number: 'P12',
      }
    }

  public readonly API_TOPUP_BILLINFO: APIType<{ session: string, mobile_number: string }, z.infer<typeof AlivCustomerSchema>> = {
    method: 'alivCustomerInfo',
    params: {
      session: 'P01',
      mobile_number: 'P02',
    },
  }

  public readonly API_CREDIT_VOUCHER: APIType<{ session: string, kioskId: string, mobile: string, email: string, amount: number, fee: number, vat: number }, any> = {
    method: 'releaseCreditVoucher',
    params: {
      session: 'P01',
      kioskId: 'P02',
      mobile: 'P03',
      email: 'P04',
      amount: 'P05',
      fee: 'P06',
      vat: 'P07'
    }
  }

  public readonly API_UTILITY_BILL_INFO: APIType<{ session: string, account_number: string, biller_tag: string, }, z.infer<typeof UtilityCustomerSchema>> = {
    method: this.UTILITY_BILL_INFO,
    params: {
      session: 'P01',
      account_number: 'P02',
      biller_tag: 'P03',
    }
  }

  public readonly API_UTILITY = {
    method: 'billpayProcessTransaction',
    params: {
      session: 'P01',
      customer_id: 'P02',
      first_field: 'P03',
      account_no: 'P04',
      biller_tag: 'P05',
      description: 'P06',
      amount: 'P07',
      name: 'P08',
      email: 'P09',
      mobile_number: 'P10',
      fee: 'P11',
      total_amount_peso: 'P12',
      country_id: 'P13',
      payment_method: 'P14',
    }
  }

  public readonly API_DEPOSIT_BANK: APIType<{ session: string, mobile_number: string, amount: number, fee_type: string, account_number: string, bank_id: number, branch_id: number, account_type: 'SAVING', account_name: string }, z.infer<typeof BankDepositSchema>> = {
    method: 'kioskDepositViaBank',
    params: {
      session: 'P01',
      mobile_number: 'P02',
      amount: 'P03',
      fee_type: 'P04',
      account_number: 'P05',
      bank_id: 'P06',
      branch_id: 'P07',
      account_type: 'P08',
      account_name: 'P09',
    }
  }

  public readonly API_GOVERNMENT_TOKEN: APIType<{ session: string }, { token: string }> = {
    method: this.GOVERNMENT_GET_TOKEN,
    params: {
      session: 'P01',
    }
  }

  public readonly API_TEST_INVOICE = {
    method: 'govPayCreateTestInvoice',
    params: {
      session: 'P01',
      item_id: 'P02',
      reference_code: 'P03',
      amount: 'P04',
      email: 'P05',
    }
  }

  public readonly API_BTC_PRODUCTS: APIType<{
    session: string, category: typeof BTC_CATEGORY,
  }, z.infer<typeof BTCProductSchema>[]> = {
      method: 'getEmidaProductList',
      params: {
        session: 'P01',
        category: 'P02'
      }
    }

  public readonly API_BTC_PRODUCT_PLANS: APIType<{
    session: string, product_id: string, mobile_number: string,
  }, z.infer<typeof BTCProductPlanSchema>> = {
      method: 'getEmidaPlan',
      params: {
        session: 'P01',
        product_id: 'P02',
        mobile_number: 'P03',
      }
    }

  public readonly API_BTC_TOPUP: APIType<{
    session: string,
    carrier_id: string,
    carrier_name: string,
    country_id: number | string,
    payment_type: 'TOPUP',
    sku_id: -1,
    mobile_number: string,
    amount: number,
    provider: 'emida',
    product_id: string,
    product_flow: '',
    invoice_number: '',
  } & (
      { plan_or_local: 'local', plan_id: '', }
      | { plan_or_local: 'plan', plan_id: BTCProductPlan['planId'], }
    )
    , z.infer<typeof TopupTransactionSchema>
  > = {
      method: 'processTopupTransaction',
      params: {
        session: 'P01',
        carrier_id: 'P02',
        carrier_name: 'P03',
        country_id: 'P04',
        payment_type: 'P05',
        sku_id: 'P06',
        mobile_number: 'P07',
        amount: 'P08',
        provider: 'P09',
        product_id: 'P10',
        product_flow: 'P11',
        invoice_number: 'P12',
        plan_or_local: 'P13',
        plan_id: 'P14'
      }
    }

  public readonly API_BANK_DEPOSIT_FEE: APIType<{ type: 'EXPRESS' | 'STANDARD' }, { description: string, fee: string, vat: string }> = {
    method: "kioskBankDepositFee",
    params: {
      type: 'P01',
    },
  }

  public readonly API_CARD_WITHDRAWAL: APIType<{
    session: string,
    amount: number,
    fee: number,
    vat: number,
    invoice_number: string,
    reference_number: string,
    cenpos_response: string,
    // tx_id: string,
  }, {
    TransactionId: string,
    InvoiceNumber: string,
    TotalToPay: string,
    Info: {
      Amount: string,
      Fee: string,
      Vat: string,
    }
  }> = {
      method: 'processCardWithdrawal',
      params: {
        session: 'P01',
        amount: 'P02',
        fee: 'P03',
        vat: 'P04',
        invoice_number: 'P05',
        reference_number: 'P06',
        cenpos_response: 'P07',
        // tx_id: 'kiosk_trx_id',
      }
    }

  public readonly API_CARD_DEPOSIT: APIType<{
    session: string,
    amount: number,
    fee: number,
    vat: number,
    invoice_number: string,
    reference_number: string,
    cenpos_response: string,
  }, {
    TransactionId: string,
    InvoiceNumber: string,
    TotalToPay: string,
    Info: {
      Amount: string,
      Fee: string,
      Vat: string,
    }
  }> = {
      method: 'processCardDeposit',
      params: {
        session: 'P01',
        amount: 'P02',
        fee: 'P03',
        vat: 'P04',
        invoice_number: 'P05',
        reference_number: 'P06',
        cenpos_response: 'P07',
      }
    }

  public readonly API_SAVE_METER_IN: APIType<{
    session: string,
    terminal_id: number,
    meters: string,
    category?: string,
  }, {}> = {
      method: 'getKioskCashInMeters',
      params: {
        session: 'P01',
        terminal_id: 'P02',
        meters: 'P03',
        category: 'P04'
      }
    }

  public readonly API_SAVE_METER_OUT: APIType<{
    session: string,
    terminal_id: number,
    meters: string,
    cassettes: string,
    category?: string,
  }, {}> = {
      method: 'getKioskCashOutMeters',
      params: {
        session: 'P01',
        terminal_id: 'P02',
        meters: 'P03',
        cassettes: 'P04',
        category: 'P05',
      }
    }
  public readonly API_UTILITY_BILLER: APIType<{
    session: string,
    country_code: 'BHS',
  }, z.infer<typeof UtilityBiller>[]> = {
      method: 'billpayGetBillersPerCountry',
      params: {
        session: 'P01',
        country_code: 'P02',
      },
      response_data: 'BStruct'
    }

  public readonly API_POPULAR_PROVIDERS: APIType<{
    session: string,
  }, {
    code: string, data: CarrierProvider[]
  }> = {
      method: 'getTopupProviders',
      params: {
        session: 'P01',
      },
    }

  public readonly API_CARRIER_LIST: APIType<{
    session: string,
    country_code: string,
    currency_code: string
  }, {
    code: string, data: Carrier[]
  }> = {
      method: this.CARRIER_LIST,
      params: {
        session: 'P01',
        country_code: 'P02',
        currency_code: 'P03',
      },
    }

  public readonly API_CARRIER_PRODUCTS: APIType<{
    session: string,
    carrier_id: number,
  }, { data: z.infer<typeof PrepaidPlan> | z.infer<typeof PrepaidPlan>[] }> = {
      method: this.SKUPERCARRIER,
      params: {
        session: 'P01',
        carrier_id: 'P02',
      },
    }


  // public readonly API_TOPUP_TRANSACTION_ALIV= {
  //   method: 'processTopupTransaction',
  //   params: {
  //     session: 'P01',
  //     carrier_id: 'P02',
  //     carrier_name: 'P03',
  //     country_id:  'P04',
  //     payment_type: 'P05',
  //     sku_id: 'P06',
  //     mobile_number:  'P07',
  //     amount: 'P08',
  //     provider:'P09',
  //     product_id:'P10',
  //     invoice_number:'P11',
  //   }
  // }
  public DEFAULT_MODULES: AccessModule[] = [
    // {
    //   "id": 14,
    //   "code": "BS",
    //   "description": "Business Services",
    //   "subtitle": "Deposit and Withdraw",
    //   "logo": ["assets/images/ic_outline-business.png"]
    // },
    // {
    //   "id": 15,
    //   "code": "BPYC",
    //   "description": "Payment Code",
    //   "subtitle": "",
    //   "logo": ["assets/images/Icon/Bill.png"]
    // },
    // {
    //   "id": 16,
    //   "code": "CWD",
    //   "description": "Cash Withdrawal",
    //   "subtitle": "Card transaction",
    //   "logo": ["assets/images/Icon/cards/visa.png", "assets/images/Icon/cards/mastercard.png"]
    // },
    // {
    //   "id": 17,
    //   "code": "CDD",
    //   "description": "Cash Deposit",
    //   "subtitle": "Card transaction",
    //   "logo": ["assets/images/Icon/cards/visa.png", "assets/images/Icon/cards/mastercard.png"]
    // },
  ];
  _ = [
    {
      "id": 1,
      "code": "SDW",
      "description": "Suncash",
      "subtitle": "Deposit and Withdraw",
      "logo": ["assets/images/suncash-logo.png"]
    },
    {
      "id": 2,
      "code": "GDW",
      "description": "Gaming",
      "subtitle": "Deposit and Withdraw",
      "logo": ["https://dev.mysuncash.com/desktop/cardholders/images/merchant/ic-gaming.png"]
    },
    {
      "id": 3,
      "code": "VGC",
      "description": "Vouchers & Gift Cards",
      "subtitle": "",
      "logo": ["https://dev.mysuncash.com/desktop/cardholders/images/merchant/ic-vouchers.png"]
    },
    {
      "id": 4,
      "code": "SNDM",
      "description": "Send Money",
      "subtitle": "Pay someone",
      "logo": ["assets/images/send-money.png"]
    },
    {
      "id": 5,
      "code": "UTL",
      "description": "Utility",
      "subtitle": "Pay utility bills",
      "logo": ["assets/images/Icon/Bill.png"],
      "unavailable": false
    },
    {
      "id": 6,
      "code": "GMT",
      "description": "Government",
      "subtitle": "Pay government bills",
      "logo": ["assets/images/Icon/Scan code.png"]
    },
    {
      "id": 7,
      "code": "SDR",
      "description": "Sand dollar",
      "subtitle": "Load and withdraw",
      "logo": ["assets/images/sand-dollar.png"]
    },
    {
      "id": 8,
      "code": "PKF",
      "description": "Parking Fee",
      "subtitle": "Parking fee estimator",
      "logo": ["https://dev.mysuncash.com/desktop/cardholders/images/merchant/parking.png"]
    },
    {
      "id": 9,
      "code": "BSP",
      "description": "Business Payments",
      "subtitle": "",
      "logo": ["assets/images/ic_outline-business.png"]
    },
    {
      "id": 11,
      "code": "MBW",
      "description": "Sand Dollar Wallets",
      "subtitle": "",
      "logo": ["assets/images/sand-dollar.png"]
    },
    {
      "id": 12,
      "code": "MTU",
      "description": "Mobile Top Up",
      "subtitle": "",
      "logo": ["assets/images/Vector.png"]
    },
    {
      "id": 13,
      "code": "BD",
      "description": "Bank Deposit",
      "subtitle": "",
      "logo": ["assets/images/bank-icon.png"],
      "unavailable": false
    }
  ]

  // public DEFAULT_MODULES: any[] = []
}

interface Fee {
  display: string;
  threshold: number;
  fee: number;
  vat: number;
}
interface FeesTiers {
  [key: string]: Fee[];
  SUNCASH: Fee[];
  UTILITY: Fee[];
  SANDDOLLAR: Fee[];
  GOVERNMENT: Fee[];
  GAMING: Fee[];
  BUSINESS_PAYMENTS: Fee[];
  SEND_MONEY: Fee[];
  BANK_DEPOSIT: Fee[];
  CARD_WITHDRAWAL: Fee[];
  CARD_DEPOSIT: Fee[];
  DEFAULT: Fee[];
};

export const SERVICE_FEES = {
  "CARD_WITHDRAWAL": "KIOSK_CARD_WITHDRAWAL",
  "CARD_DEPOSIT": "KIOSK_CARD_DEPOSIT",
  "SEND_MONEY": "DOMESTICSENDMONEY_KIOSK",
  "WESTERN_UNION": "WESTERN_UNION"
} as const

export const FEES_TIERS: FeesTiers = {
  DEFAULT: [
    {
      display: "$1 to $49",
      threshold: 49,
      fee: 0,
      vat: 0,
    },
    {
      display: "$50 to $99.99",
      threshold: 99.99,
      fee: 0,
      vat: 0,
    },
    {
      display: "$100 to $199.99",
      threshold: 199.99,
      fee: 0,
      vat: 0,
    },
    {
      display: "$200 and above",
      threshold: 200,
      fee: 0,
      vat: 0,
    },
  ],
  SUNCASH: [
    {
      display: "$1 to $49",
      threshold: 49,
      fee: 0,
      vat: 0,
    },
    {
      display: "$50 to $99.99",
      threshold: 99.99,
      fee: 0,
      vat: 0,
    },
    {
      display: "$100 to $199.99",
      threshold: 199.99,
      fee: 0,
      vat: 0,
    },
    {
      display: "$200 and above",
      threshold: 200,
      fee: 0,
      vat: 0,
    },
  ],
  GAMING: [
    {
      display: "$1 to $49",
      threshold: 49,
      fee: 0,
      vat: 0,
    },
    {
      display: "$50 to $199",
      threshold: 199,
      fee: 0,
      vat: 0,
    },
    {
      display: "$200 and above",
      threshold: 200,
      fee: 0,
      vat: 0,
    },
  ],
  SANDDOLLAR: [
    {
      display: "$1 to $49",
      threshold: 49,
      fee: 0,
      vat: 0,
    },
    {
      display: "$50 to $199",
      threshold: 199,
      fee: 0,
      vat: 0,
    },
    {
      display: "$200 and above",
      threshold: 200,
      fee: 0,
      vat: 0,
    },
  ],
  SEND_MONEY: [
    {
      display: "$1 to $49",
      threshold: 49,
      fee: 0,
      vat: 0,
    },
    {
      display: "$50 to $199",
      threshold: 199,
      fee: 0,
      vat: 0,
    },
    {
      display: "$200 to $249",
      threshold: 249,
      fee: 0,
      vat: 0,
    },
    {
      display: "$250 to $1000",
      threshold: 250,
      fee: 0,
      vat: 0,
    },
  ],
  UTILITY: [
    {
      display: "$1 to $49",
      threshold: 49,
      fee: 0,
      vat: 0,
    },
    {
      display: "$50 to $199",
      threshold: 199,
      fee: 0,
      vat: 0,
    },
    {
      display: "$200 to $249",
      threshold: 249,
      fee: 0,
      vat: 0,
    },
    {
      display: "$250 and above",
      threshold: 250,
      fee: 0,
      vat: 0,
    },
  ],
  GOVERNMENT: [
    {
      display: "$1 to $49",
      threshold: 49,
      fee: 0,
      vat: 0,
    },
    {
      display: "$50 to $199",
      threshold: 199,
      fee: 0,
      vat: 0,
    },
    {
      display: "$200 to $249",
      threshold: 249,
      fee: 0,
      vat: 0,
    },
    {
      display: "$250 and above",
      threshold: 250,
      fee: 0,
      vat: 0,
    },],
  BANK_DEPOSIT: [
    {
      display: "$1 to $49",
      threshold: 49,
      fee: 0,
      vat: 0,
    },
    {
      display: "$50 to $199",
      threshold: 199,
      fee: 0,
      vat: 0,
    },
    {
      display: "$200 to $249",
      threshold: 249,
      fee: 0,
      vat: 0,
    },
    {
      display: "$250 and above",
      threshold: 250,
      fee: 0,
      vat: 0,
    },
  ],
  BUSINESS_PAYMENTS: [
    {
      display: "$1 to $49",
      threshold: 49,
      fee: 0,
      vat: 0,
    },
    {
      display: "$50 to $199",
      threshold: 199,
      fee: 0,
      vat: 0,
    },
    {
      display: "$200 to $249",
      threshold: 249,
      fee: 0,
      vat: 0,
    },
    {
      display: "$250 and above",
      threshold: 250,
      fee: 0,
      vat: 0,
    },
  ],
  CARD_WITHDRAWAL: [
    {
      display: "$1 to $49",
      threshold: 49,
      fee: 2,
      vat: 0,
    },
    {
      display: "$50 to $99",
      threshold: 99,
      fee: 3,
      vat: 0,
    },
    {
      display: "$100 to $199",
      threshold: 199,
      fee: 5,
      vat: 0,
    },
    {
      display: "$200 and 299",
      threshold: 299,
      fee: 7,
      vat: 0,
    },
    {
      display: "$300 and above",
      threshold: 300,
      fee: 10,
      vat: 0,
    },
  ],
  CARD_DEPOSIT: [
    {
      display: "$1 to $49",
      threshold: 49,
      fee: 0,
      vat: 0,
    },
    {
      display: "$50 to $199",
      threshold: 199,
      fee: 0,
      vat: 0,
    },
    {
      display: "$200 to $249",
      threshold: 249,
      fee: 0,
      vat: 0,
    },
    {
      display: "$250 and above",
      threshold: 250,
      fee: 0,
      vat: 0,
    },
  ],
  WESTERN_UNION: [
    {
      display: "$1 to $49",
      threshold: 49,
      fee: 0,
      vat: 0,
    },
    {
      display: "$50 to $199",
      threshold: 199,
      fee: 0,
      vat: 0,
    },
    {
      display: "$200 to $249",
      threshold: 249,
      fee: 0,
      vat: 0,
    },
    {
      display: "$250 and above",
      threshold: 250,
      fee: 0,
      vat: 0,
    },
  ],
}
